import { createStyles } from 'antd-style'

const VISIBLE_ROWS = 14
const FADE_EDGE_ALPHA = 'rgba(0, 0, 0, 0.35)'
const FADE_OPAQUE = '#000'

export const useStyles = createStyles(({ token }) => {
  const headerEdge = token.controlHeightLG
  const fadeSize = token.controlHeight
  const topFade = `${FADE_OPAQUE} ${headerEdge}px, ${FADE_EDGE_ALPHA} ${headerEdge}px, ${FADE_OPAQUE} ${headerEdge + fadeSize}px`
  const bottomFade = `${FADE_OPAQUE} calc(100% - ${fadeSize}px), ${FADE_EDGE_ALPHA} 100%`

  return {
    scroller: {
      position: 'relative',
      maxHeight: token.controlHeight * VISIBLE_ROWS,
      overflowY: 'auto',
      scrollbarGutter: 'stable',
      '&[data-fade-top]': {
        maskImage: `linear-gradient(to bottom, ${topFade})`
      },
      '&[data-fade-bottom]': {
        maskImage: `linear-gradient(to bottom, ${bottomFade})`
      },
      '&[data-fade-top][data-fade-bottom]': {
        maskImage: `linear-gradient(to bottom, ${topFade}, ${bottomFade})`
      }
    },
    header: {
      minHeight: token.controlHeightLG,
      borderRadius: token.borderRadius,
      '&::before': {
        content: '""',
        position: 'absolute',
        insetBlock: 0,
        insetInline: -token.marginXXS,
        zIndex: -1,
        backgroundColor: token.colorBgElevated
      },
      '&::after': {
        content: '""',
        position: 'absolute',
        inset: 0,
        zIndex: -1,
        borderRadius: token.borderRadius,
        transition: `background-color ${token.motionDurationFast} ${token.motionEaseOut}`
      },
      '&:hover::after': {
        backgroundColor: token.controlItemBgHover
      }
    },
    chevron: {
      color: token.colorTextSecondary,
      transition: `transform ${token.motionDurationMid} ${token.motionEaseOut}`
    },
    chevronOpen: {
      transform: 'rotate(90deg)'
    }
  }
})
